import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';

import { LoadingHeader } from '../../header';
import * as Styled from '../../purchase-premium.style';

export type PurchasePremiumErrorProps = {
  onClose: () => void;
  onRetry: () => void;
};

export const PurchasePremiumError: React.FC<PurchasePremiumErrorProps> = ({
  onClose,
  onRetry,
}) => {
  const { t } = useTranslation();

  return (
    <Styled.Container>
      <LoadingHeader onClose={onClose} />

      <Styled.Body>
        <Styled.PaymentForm>
          <Typography variant="h5" component="h1">
            {t('dialogs.purchase-premium.error.title')}
          </Typography>
          <Typography variant="body2">
            {t('dialogs.purchase-premium.error.description')}
          </Typography>

          <Styled.Interactions>
            <Button
              variant={Variants.Contained}
              size={Sizes.Large}
              color={Colors.Primary}
              onClick={onRetry}
              fullWidth
              alignCenter
            >
              {t('dialogs.purchase-premium.error.interactions.retry')}
            </Button>
          </Styled.Interactions>
        </Styled.PaymentForm>
      </Styled.Body>
    </Styled.Container>
  );
};
